import { Link } from 'react-router-dom';
import { Upload, Bot, Users, ShieldCheck, MessageCircle, Star, ArrowRight } from 'lucide-react';
import { MarketingLayout } from '@/components/layout/MarketingLayout';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

export function ComoFunciona() {
  return (
    <MarketingLayout>
      <div className="container-px mx-auto max-w-5xl py-16 sm:py-24">
        <h1 className="font-serif text-display-lg text-balance">Como funciona</h1>
        <p className="mt-4 text-lg text-muted-foreground text-pretty max-w-2xl">
          Do upload do contrato até a aprovação da revisão — passo a passo, sem reuniões.
        </p>

        <div className="mt-16 space-y-12">
          {[
            {
              n: 1,
              icon: Upload,
              title: 'Você sobe o contrato',
              body: 'Aceita PDF e DOCX até 20MB. Os dados ficam criptografados em S3 com chave dedicada — só você e o advogado contratado têm acesso.',
            },
            {
              n: 2,
              icon: Bot,
              title: 'A IA faz a pré-análise em segundos',
              body: 'Usamos Claude Sonnet 4 (o mesmo modelo que você acessa pelo claude.ai, rodando na infra AWS). Ele identifica tipo de contrato, partes, cláusulas críticas e classifica cada uma como baixo, médio ou alto risco — com sugestões de redação.',
            },
            {
              n: 3,
              icon: Users,
              title: 'Você escolhe um advogado',
              body: 'Veja a especialidade recomendada pela IA, filtre por avaliação e faixa de preço, leia avaliações públicas. O advogado define a própria tabela — Parecer.ai não controla preços.',
            },
            {
              n: 4,
              icon: ShieldCheck,
              title: 'Pagamento com escrow',
              body: 'Você paga via Pagar.me (PIX, cartão ou boleto). O dinheiro fica retido pela janela de recebimento. Só é liberado quando você aprovar a entrega — split automático: 85% advogado, 15% plataforma.',
            },
            {
              n: 5,
              icon: MessageCircle,
              title: 'Conversa direto na plataforma',
              body: 'Chat em tempo real, videocall via Daily.co (com gravação opcional), troca de arquivos. Tudo em um só lugar.',
            },
            {
              n: 6,
              icon: Star,
              title: 'Você aprova e avalia',
              body: 'Recebeu a revisão, aprovou? Pagamento liberado, advogado avaliado. Histórico de versões fica disponível pra você baixar quando quiser.',
            },
          ].map((step) => (
            <div key={step.n} className="flex flex-col sm:flex-row gap-6 sm:gap-10">
              <div className="flex sm:flex-col items-center sm:items-start gap-4 sm:gap-2 sm:w-32 flex-none">
                <span className="font-serif text-5xl text-accent">{step.n}</span>
                <step.icon className="h-5 w-5 text-muted-foreground" />
              </div>
              <Card className="flex-1">
                <CardContent className="pt-6">
                  <h2 className="font-serif text-2xl">{step.title}</h2>
                  <p className="mt-2 text-muted-foreground text-pretty">{step.body}</p>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>

        <div className="mt-20 rounded-lg border bg-surface/40 p-8">
          <h3 className="font-serif text-2xl">Sobre a verificação de OAB</h3>
          <p className="mt-2 text-muted-foreground">
            No MVP, advogados se cadastram com número e seccional da OAB, mas a verificação é manual pelo time da plataforma. Em breve, integraremos consulta automática à OAB nacional.
          </p>
        </div>

        <div className="mt-12 flex justify-center">
          <Button asChild size="lg" variant="accent" className="gap-2">
            <Link to="/cadastro">
              Começar agora
              <ArrowRight className="h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </MarketingLayout>
  );
}
